import { Injectable } from '@angular/core';
import { BackendService } from '../../services/new-http/backend.service';

@Injectable({
    providedIn: 'root',
})
export class StocksApiService extends BackendService {
    public get(url: string) {
        return this.stocksApi.get(url);
    }

    public put(url: string, body: any) {
        return this.stocksApi.put(url, body)
    }

    public post(url: string, body: any) {
        return this.stocksApi.post(url, body)
    }
}